import axios from "axios";
import { Config } from "../app.configs";
import { PaymentIntent } from "../models";
import { BaseService, ErrorData } from "./base.service";
import { getChannelSource } from "../utils";

export class CybersourceUbaService extends BaseService {
    private getHeaders() {
        const metaHeaders = getChannelSource();
        return {
            "Content-Type": "application/json",
            ...metaHeaders
        };
    }

    createPayment(token: string, append = {}): Promise<any | ErrorData> {
        const params = {
            token,
            ...append,
            include: "customer.phone_number,currency,customer.account"
        };

        return axios
            .post(Config.toApiUrl("cybersource_uba"), params, {
                headers: this.getHeaders()
            })
            .then((response: any) => {
                const intent = new PaymentIntent(response.data.intent);

                return { intent, capture_context: response.data.cybersource_session };
            })
            .catch(this.handleError);
    }

    verify(
        token: string,
        pi_reference: string,
        transient_token: string
    ): Promise<PaymentIntent | ErrorData> {
        const params = { token, pi_reference, transient_token };

        return axios
            .post(Config.toApiUrl("cybersource_uba/verify"), params, {
                headers: this.getHeaders()
            })
            .then((data: any) => {
                return new PaymentIntent(data.data["v1/payment_intent"]);
            })
            .catch(this.handleError);
    }
}
